<template>
  <div class="layout">
    <!-- 左侧菜单 -->
    <Sidebar />

    <!-- 主体内容区 -->
    <div class="main-content">
      <HeaderBar />
      <router-view></router-view>
    </div>
  </div>
</template>

<script setup>
import Sidebar from '@/components/Sidebar.vue'
import HeaderBar from '@/components/HeaderBar.vue'
</script>

<style scoped>
.layout {
  display: flex;
  height: 100vh;
  background-color: #f5f6fa;
}
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
